import * as yup from 'yup';
import dayjs from "dayjs";

export const validateRowSchema = yup.object().shape({
    id: yup
        .string()
        .required("Required"),
    itemId: yup
        .string(),
    // .required("Required"),
    qty: yup
        .number()
        .typeError("Number Only")
        .required("Required"),
    itemName: yup
        .string()
        .required("Required"),
    code: yup
        .string()
        .required("Required"),
    description: yup
        .string()
        .required("Required"),
})

export const validationSchema = yup.object({
    locationId: yup
        .string()
        .required("Required"),
    toLocationId: yup
        .string()
        .required("Required"),
    repoNumber: yup
        .string()
        .required("Required"),
    repoAlternativeNumber: yup
        .string()
        .required("Required"),
    numberSeal: yup
        .string()
        .required("Required"),
    repoMarking: yup
        .string()
        .required("Required"),
    initialDate: yup
        .date("Invalid")
        .required("Required")
        .typeError("Invalid"),
    loadDate: yup
        .date("Invalid")
        .required("Required")
        .typeError("Invalid"),
    supervisor: yup
        .string()
        .required("Required"),
    shipper: yup
        .string()
        .required("Required"),
    customAgent: yup
        .string()
        .required("Required"),
    // rows: yup.array().of(validateRowSchema)

})

export const initialRowValues = {
    id: 0,
    itemId: "",
    qty: "",
    itemName: "",
    code: "",
    description: "",
    itemRemark: "",
    uomLabel: "",
    uomId: "",
    price: ""
}

export const initialValues = {
    repoNumber: "",
    repoAlternativeNumber: "",
    numberSeal: "",
    repoMarking: "",
    initialDate: dayjs(),
    loadDate: dayjs(),
    supervisor: "",
    shipper: "",
    customAgent: "",
    remark: "",
    rows: [initialRowValues],
    locationId: "",
    locationName: "",
    toLocationId: "",
    toLocationName: ""
} 